import { createFileRoute } from '@tanstack/react-router'
import { ServiceJobsPage } from '../../../../features/service/register-page'
import { serviceJobSearchSchema } from '../../../../features/service/search'

export const Route = createFileRoute('/_app/service/jobs/')({
  validateSearch: serviceJobSearchSchema,
  component: ServiceJobsPage,
})
